import { AGGREGATE_NAMES, type LOAN_REQUEST_OFFER_SOURCE, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetOfferAcceptanceStatusByOfferId } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

type Props = {
    loanRequestId: string;
    offerId: string;
    source: LOAN_REQUEST_OFFER_SOURCE;
};

export const useOfferAcceptanceStatusByOfferId = ({ loanRequestId, offerId, source }: Props) => {
    return useAggregateQuery({
        acl: { loanRequestId },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getOfferAcceptanceStatusByOfferId,
        schema: schemaLoanRequestResolver_GetOfferAcceptanceStatusByOfferId,
        searchParams: { id: loanRequestId, offerId, source },
    });
};
